import { giphyDarkestGrey, giphyLightGrey } from '@giphy/colors'
import { useContext } from 'react'
import styled from 'styled-components'
import { Button } from 'ui'
import CreationToolStatus from '../../types/status'
import { CreationToolUploadContext } from './manager'
import UploadButton from './upload-button'

const Container = styled.div`
    background: ${giphyDarkestGrey};
    bottom: 0;
    margin: 0 -10px;
    padding-bottom: 10px;
    position: sticky;
    z-index: 1;
    text-align: center;
`

const DownloadButton = styled(Button)`
    margin: 10px auto 0;
    width: 100%;
`

const CreationUploadButtons = () => {
    const { download, allowDownload, status } = useContext(CreationToolUploadContext)
    const isIdle = status === CreationToolStatus.Idle
    return (
        <Container>
            <UploadButton />
            {allowDownload && (
                <DownloadButton
                    color="transparent"
                    disabled={!isIdle}
                    size="medium"
                    textColor={giphyLightGrey}
                    onClick={download}
                >
                    Download
                </DownloadButton>
            )}
        </Container>
    )
}

export default CreationUploadButtons
